import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
import language from "../../store/country/language";

const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            title: '',
            content: '',
            date: '',
            files: [],
            langOption: 30,
            wid: '',
            wp_id: '',
            be_start: '',
            be_end: '',
            category: '',
            seq: '',
            name: '',
            bc_idx: '',
            wr_seq: '',
            headText: '',
            language: '',
            background: [],
            thumbnail: [],
        }
    },
    validators: {
        title: function (value) {
            return Validator.value(value)
                .required('제목을 입력해 주세요.')
        },
        date: function (value) {
            return Validator.value(value)
                .required('작성일을 선택해 주세요.')
        },
        language: function (value) {
            return Validator.value(value)
                .required('언어를 입력해 주세요.')
        },
        backimg: function (value) {
            return Validator.value(value)
        },
        thumbnail: function (value) {
            return Validator.value(value)
        },
        content: function (value) {
            return Validator.value(value)
                .required('내용을 입력해 주세요.')
        },
        headText: function (value) {
            return Validator.value(value)
                .required('말머리를 입력해 주세요.')
        },
        files: function (value) {
            return Validator.value(value)
                .required('이미지를 선택해 주세요.')
        },
        langOption: function (value) {
            return Validator.value(value)
        },
        wid: function (value) {
            return Validator.value(value)
        },
        wp_id: function (value) {
            return Validator.value(value)
        },
        be_start: function (value) {
            return Validator.value(value)
                .required('시작날짜를 선택해 주세요.')
        },
        be_end: function (value) {
            return Validator.value(value)
        },
        category: function (value) {
            return Validator.value(value)
                .required('카테고리를 선택해 주세요.')
        },
        seq: function (value) {
            return Validator.value(value)
                .required('순서를 입력해 주세요.')
        },
        name: function (value) {
            return Validator.value(value)
                .required('카테고리명을 입력해 주세요.')
        },
        bc_idx: function (value) {
            return Validator.value(value)
                .required('카테고리명를 선택해 주세요.')
        },
        wr_seq: function (value) {
            return Validator.value(value)
                .required('순서를 입력해 주세요.')
        },
    }
}
